// L'app se croit-elle connectée ?
//
// POURQUOI CE DRAPEAU EXISTE
// --------------------------
// Deux situations envoient la clé anon sur le réseau, et elles sont
// indiscernables au niveau du transport :
//
//  1. un visiteur anonyme sur `/book` : normal, attendu, la RLS le prévoit ;
//  2. l'app se croit connectée mais le jeton a disparu : c'est le bug qui a
//     produit 192 erreurs `42501` en trois minutes le 2026-08-23.
//
// Seule l'application sait laquelle des deux est en cours. Ce drapeau porte
// cette information jusqu'à la porte (`sessionGuardedFetch.ts`).
//
// Il vit dans son propre fichier, SANS aucune dépendance, précisément pour que
// `client.ts` puisse l'importer sans créer de cycle.

let expected = false;
let loggingOut = false;

/** Une session est installée : toute requête REST doit désormais porter un JWT. */
export function markSessionExpected(): void {
  expected = true;
  // Une nouvelle session clôt toute déconnexion restée ouverte.
  loggingOut = false;
}

/** Plus de session : la clé anon redevient légitime (tunnel `/book`). */
export function markSessionAbsent(): void {
  expected = false;
}

export function isSessionExpected(): boolean {
  return expected;
}

// Déconnexion volontaire en cours (spec du 2026-09-27). Les lectures lancées
// juste avant le clic attendent le verrou d'auth de supabase-js ; celles placées
// derrière `signOut` dans la file partent sans session, depuis une page souvent
// déjà publique (`/`). Tant que ce drapeau est levé, la porte les retient en
// silence quelle que soit la page. Il DOIT retomber : sur mobile, la
// déconnexion mène à l'accueil natif, qui lit légitimement en anon.

/** Début de `signOut`, avant tout `await`. */
export function markLogoutStarted(): void {
  loggingOut = true;
}

/** Fin de `signOut`. */
export function markLogoutFinished(): void {
  loggingOut = false;
}

export function isLogoutInProgress(): boolean {
  return loggingOut;
}

/** Remise à zéro entre deux tests. */
export function __resetSessionExpectationForTests(): void {
  expected = false;
  loggingOut = false;
}
